import React, { useEffect, useState } from 'react';

import { differenceInSeconds } from 'date-fns';

import { formatDuration } from '@/helpers/dates';

interface IElapsedTimerProps {
  startedAt: string;
}

const toElapsedSeconds = (startedAt: string): number =>
  differenceInSeconds(new Date(), new Date(startedAt));

export const ElapsedTimer = ({ startedAt }: IElapsedTimerProps) => {
  const [elapsed, setElapsed] = useState(() => toElapsedSeconds(startedAt));

  useEffect(() => {
    const id = setInterval(() => {
      setElapsed(toElapsedSeconds(startedAt));
    }, 1000);

    return () => clearInterval(id);
  }, [startedAt]);

  return <span>{formatDuration(elapsed)}</span>;
};
